module.exports = __webpack_public_path__ + "static/img/A79.e55b0a0d.jpg";